/**
 * Notification Service
 *
 * API client for notification-related endpoints.
 */

import { fetchApi } from '@/shared/services/api';
import type {
  NotificationListParams,
  NotificationRead,
  PaginatedResponse,
  UnreadCountResponse,
} from '@/shared/types';

export const notificationService = {
  /** Paginated list, newest first */
  list: (params?: NotificationListParams) =>
    fetchApi<PaginatedResponse<NotificationRead>>('/notifications', {
      params: params as Record<string, unknown>,
    }),

  /** Unread badge count */
  getUnreadCount: () =>
    fetchApi<UnreadCountResponse>('/notifications/unread-count'),

  /** Mark single notification as read */
  markAsRead: (id: string) =>
    fetchApi<NotificationRead>(`/notifications/${id}/read`, { method: 'PATCH' }),

  /** Bulk mark all as read */
  markAllAsRead: () =>
    fetchApi<{ count: number }>('/notifications/read-all', { method: 'POST' }),

  /** Permanently dismiss a notification */
  dismiss: (id: string) =>
    fetchApi<void>(`/notifications/${id}`, { method: 'DELETE' }),
};
